import React from 'react'
import ImageAvatar from './ImageAvatar'

const ContactAvatar = props => {
  return <ImageAvatar {...props} />
}

export default ContactAvatar
